import React, { ReactNode } from "react";

import { SvgIcon } from "@mui/material";

import Category from "../icons/iconly/bulk/category";
import Graph from "../icons/iconly/bulk/graph";
import Settings from "../icons/iconly/bulk/settings";
import { useIsHostedCluster } from "@/hooks/use-is-hosted-cluster";

export interface Item {
  external?: boolean;
  icon?: ReactNode;
  items?: Item[];
  path?: string;
  title: string;
  disabled?: boolean;
}

export const useMenuItems = (): Item[] => {
  const isHostedCluster = useIsHostedCluster();

  const reportItems = [
    {
      title: `Traffic`,
      path: "/app/reports/traffic",
    },
    ...(!isHostedCluster
      ? [
          {
            title: `Status`,
            path: "/app/reports/status",
          },
        ]
      : []),
    {
      title: `Deployments`,
      path: "/app/reports/deployments",
    },
    ...(!isHostedCluster
      ? [
          {
            title: `Usage`,
            path: "/app/reports/usage",
          },
        ]
      : []),
    ...(isHostedCluster
      ? [
          {
            title: `Logs`,
            path: "/app/reports/logs",
          },
        ]
      : []),
  ];

  return [
    {
      title: "Reports",
      icon: (
        <SvgIcon>
          <Graph />
        </SvgIcon>
      ),
      items: reportItems,
    },
    {
      title: "Manage",
      icon: (
        <SvgIcon>
          <Category />
        </SvgIcon>
      ),
      items: [
        {
          title: `Routes`,
          path: "/app/management/routes",
        },
        {
          title: `Policies`,
          path: "/app/management/policies",
        },
        {
          title: `Certificates`,
          path: "/app/management/certificates",
        },
        {
          title: `Service Accounts`,
          path: "/app/management/service-accounts",
        },
      ],
    },
    {
      title: "Settings",
      icon: (
        <SvgIcon>
          <Settings />
        </SvgIcon>
      ),
      path: "/app/settings",
    },
  ];
};
